import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router =  new Router({
  mode: "history",
  routes: [
    {
      path: '*',
      redirect: "/"
    },
    {
      path: '/',
      name: 'index',
      component: () => import("@/components/index")
    },
    {
      path: '/game',
      name: 'game',
      component: () => import("@/components/games/index")
    },
    {
      path: '/leader',
      name: 'leader',
      component: () => import("@/components/leaderboard")
    },
    {
      path: '/rules',
      name: 'rules',
      component: () => import("@/components/rules")
    },
    {
      path: '/history',
      name: 'history',
      component: () => import("@/components/history")
    }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getExpire('token')
  if (!token && to.path != '/') {
    localStorage.clear()
    next('/')
  } else {
    next()
  }
})

const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js